import { selectPersonReferenceNode } from '@newStore/documentUI/transformContent/referenceGroupSelectors';
import { isReferenceContactPersonActive } from '@newStore/validation/validationRules/contactPersonActive';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';

const PERSON_REFERENCE: BuildingBlockNodeConfig = {
  nodeSelector: selectPersonReferenceNode,
  validationRules: [isReferenceContactPersonActive],
  information: {
    single: '(Contact)persoon',
    plural: '(Contact)personen',
    ribonIcon: require('../../../../img/buildingBlocks/PERSON.svg'),
  },
  buildingBlocks: [],
  edit: [],
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: false,
  },
  readOnlyNode: true,
};

export default PERSON_REFERENCE;
